import React from 'react';
import Table from "components/Table/Table.jsx";
import SortButton from "components/SortButton/SortButton.jsx";

export const CONTACT_COLUMNS_META = [
    { accessor: 'number', Header: '#' },
    { accessor: 'first_name', Header: 'First Name' },
    { accessor: 'last_name', Header: 'Last Name' },
    { accessor: 'contact_type', Header: 'Contact Type' },
    { accessor: 'companies', Header: 'Companies' },
    { accessor: 'email', Header: 'Email' },
    { accessor: 'created_date', Header: 'Created' },
    { accessor: 'created_by', Header: 'Created By' },
];

const ContactsListTable = props => {
    const {
        userType,
        setSort,
        sortDirection,
        sortBy,
        hiddenColumns = []
    } = props;

    const fullHead = [
        '#',
        <strong>First Name<SortButton setSort={setSort} sortBy='first_name' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Last Name<SortButton setSort={setSort} sortBy='last_name' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Contact Type<SortButton setSort={setSort} sortBy='contact_type' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Companies</strong>,
        <strong>Email</strong>,
        <strong>Created<SortButton setSort={setSort} sortBy='created_date' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Created By</strong>,
    ];

    const hiddenIdx = new Set();
    CONTACT_COLUMNS_META.forEach((c, i) => {
        if (hiddenColumns.indexOf(c.accessor) !== -1) hiddenIdx.add(i);
    });

    const filteredHead = fullHead.filter((_, i) => !hiddenIdx.has(i));
    const filteredData = (props.dataArr || []).map(row => row.filter((_, i) => !hiddenIdx.has(i)));

    return <div>
        {props.data[userType].length !== 0 && <Table
          tableHeaderColor="primary"
          tableHead={filteredHead}
          tableData={filteredData}
        />}
    </div>
}

export default ContactsListTable;